import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Input, Select } from 'antd';
import { saveParams } from '../../../actions/noticeActions';

const Option = Select.Option;

class Filter extends Component {
    constructor(props) {
        super(props);
        const { params } = this.props;
        const { siteName = '', employeeCode = '' } = params || {};
        this.state = {
            searchParams: { siteName, employeeCode },
        }
    }

    componentDidMount() {
        this.search();
    }

    componentWillUnmount() {
        const { saveParams } = this.props;
        saveParams({ 
            siteName: '',
            employeeCode: '',
        });
    }

    search = () => {
        const { searchParams } = this.state;
        this.props.search(searchParams);
    }

    export = () => {
        this.props.export();
    }

    enterSearch = e => {
        if (e.charCode === 13) {
            this.search();
        }
    }

    handleSelectChange = (value, field) => {
        const { searchParams } = this.state;
        searchParams[field] = value;
        this.setState({ searchParams });
    }

    handleInputChange = (e, field) => {
        const { searchParams } = this.state;
        searchParams[field] = e.target.value;
        this.setState({ searchParams });
    }

    render() {
        const { curRole } = sessionStorage;
        const { searchParams: { siteName, employeeCode } } = this.state;
        return (
            <div className="filter-bar">
                <div className="form-item">
                    <label className="ui-label">中心编号</label>
                    <Input
                        placeholder='请输入'
                        onKeyPress={this.enterSearch}
                        onChange={e => this.handleInputChange(e, 'siteCode')}
                    />
                </div>
                <div className="form-item">
                    <label className="ui-label">中心名称</label>
                    <Input
                        value={siteName}
                        placeholder='请输入'
                        onKeyPress={this.enterSearch}
                        onChange={e => this.handleInputChange(e, 'siteName')}
                    />
                </div>
                <div className="form-item">
                    <label className="ui-label">工号</label>
                    <Input
                        value={employeeCode}
                        placeholder='请输入'
                        onKeyPress={this.enterSearch}
                        onChange={e => this.handleInputChange(e, 'employeeCode')}
                    />
                </div>
                <div className="form-item">
                    <label className="ui-label">姓名</label>
                    <Input
                        placeholder='请输入'
                        onKeyPress={this.enterSearch}
                        onChange={e => this.handleInputChange(e, 'employeeName')}
                    />
                </div>
                <div className="form-item">
                    <label className="ui-label">人员状态</label>
                    <Select style={{ width: 80 }} placeholder='请选择' allowClear={true} onChange={value => this.handleSelectChange(value, 'employeeStatus')}>
                        <Option value="WORKING">现任</Option>
                        <Option value="WORKED">前任</Option>
                        <Option value="LEFT">离职</Option>
                        <Option value="LEAVE">离任</Option>
                        <Option value="LAST_TERM">最后任</Option>

                    </Select>
                </div>
                <div className="form-item">
                    {
                      curRole != 'CRC' &&  <Button type="primary" onClick={this.export}>导出</Button>
                    }
                    <Button type="primary" onClick={this.search}>搜索</Button>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state, props) => {
    return {
        params: state.noticeState.params,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        saveParams: (params) => dispatch(saveParams(params)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Filter);


// WEBPACK FOOTER //
// ./src/components/member/crcInfo/Filter.js